import "./styles.scss";

import moment from "moment";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { getTransactionsByFilter, postSetPaymentsStatus, putTransactionsSetStatus } from "../../../store/middleware";

function Transactions() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");
  const { user } = useSelector((state) => state.userReducer);
  const { affiliateInfo, affiliateTransactions } = useSelector((state) => state.affiliateReducer);

  const [dateEnd, setDateEnd] = useState(null);
  const [dateStart, setDateStart] = useState(null);

  const isManager = user?.role === "companyManager" || user?.role === "customerService";

  const getData = async (start = "", end = "") => {
    const endAt = end ? end : moment().format("YYYY-MM-DD");
    const startAt = start ? start : moment().subtract(1, "months").format("YYYY-MM-DD");

    setDateEnd(endAt);
    setDateStart(startAt);

    await dispatch(getTransactionsByFilter({ endAt, startAt, status: "", affiliateId: affiliateInfo.id }));
  };

  const balanceTotal = affiliateTransactions?.reduce((acc, item) => acc + item.value, 0);

  const handleFilter = (e) => {
    e.preventDefault();
    getData(dateStart, dateEnd);
  };

  const renderTranslateDateMonth = (date) => {
    const day = moment(date).format("DD");
    const month = moment(date).format("MMMM");
    const year = moment(date).format("YYYY");

    return `${day} ${t(month.toUpperCase()).toLowerCase()} ${year}`;
  };

  const displayNumberToDecimal = (number = 0) => {
    const isEN = lang === "en" || lang === "en-US";
    return Number(number)
      .toFixed(2)
      .replace(".", isEN ? "." : ",");
  };

  const handleConfirmPayment = async (e, id) => {
    e.preventDefault();

    await dispatch(putTransactionsSetStatus({ status: "paid", userId: user.id, affiliatePaymentId: id })).then(
      (resp) => resp && getData(),
    );
  };

  const handleConfirmAllPayment = async (e) => {
    e.preventDefault();

    if (!affiliateTransactions.length) return;

    const transactions = affiliateTransactions
      ?.filter((item) => item.status !== "paid")
      ?.map((item) => ({ id: item.id }));

    await dispatch(postSetPaymentsStatus({ payments: transactions, userId: user.id })).then(
      (resp) => resp && getData(),
    );
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="containerTransactions">
      <h2 className="title">{!isManager ? t("TRANSACTIONS") : ""}</h2>

      <div className="wrapperFilterBalance">
        <div className="filter">
          <div>
            <label className="labelFilter">{t("PERIOD_START")}</label>
            <input type="date" value={dateStart} onChange={(e) => setDateStart(e.target.value)} />
          </div>
          <div>
            <label className="labelFilter">{t("PERIOD_START")}</label>
            <input type="date" value={dateEnd} onChange={(e) => setDateEnd(e.target.value)} />
          </div>

          <button onClick={handleFilter} className="buttonFilter">
            {t("FILTER")}
          </button>
        </div>

        <div className="balance">
          {user?.role === "companyManager" && (
            <button onClick={handleConfirmAllPayment} className="buttonFilter">
              {t("PAY_ALL")}
            </button>
          )}

          <p className="textBalance">
            {t("CURRENT_BALANCE")} <span>$ {displayNumberToDecimal(balanceTotal)}</span>
          </p>
        </div>
      </div>

      {affiliateTransactions?.map((item) => (
        <div key={item.id} className="wrapperList">
          <div className="headerList">
            <p className="textHeaderList">{renderTranslateDateMonth(item.createdAt)}</p>
          </div>

          <div className="rowList">
            <p className="titleList">
              {t("COMMISSION")} {item.reference}
            </p>

            <div className="wrapperPaymentButton">
              {item.paidByWhoID && <p>{t("PAYMENT") + " ID - " + item.id}</p>}

              {user?.role === "companyManager" && item.status === "pending" && (
                <button className="buttonConfirmPayment" onClick={(e) => handleConfirmPayment(e, item.id)}>
                  {t("BTN_CONFIRM") + " " + t("PAYMENT")}
                </button>
              )}
            </div>
          </div>

          <div className="rowList">
            <p className="valueList" data-item={item.status.toUpperCase()}>
              {t(item.status.toUpperCase())}
            </p>
            <p className="titleList backGreen">
              {item.currency === "USD" ? "$" : "R$"} {displayNumberToDecimal(item.value)}
            </p>
          </div>
        </div>
      ))}

      {affiliateTransactions?.length === 0 && <h4>{t("NO_ITEMS_FOUND")}</h4>}
    </div>
  );
}

export default Transactions;
